export const environment = {
  WS_GRAPHQL_ENDPOINT: 'wss://api.fitness.np.rebac.eu/graphql',
  HTTP_GRAPHQL_ENDPOINT: 'https://api.fitness.np.rebac.eu/graphql',
  MAINTENANCE_STATUS_ENDPOINT: 'https://status.np.gym-deals.de/status.json',
  AUTH0_GRAPHQL_AUDIENCE: 'https://graphql.fitness.np.rebac.de',
  AUTH0_DOMAIN: 'rebac-fitness-np.eu.auth0.com',
  AUTH0_CLIENT_ID: 'jgZ5P099XHZvG6jCu0g4MBYTCzmdKhtW',
  ASSET_URL:
    'https://rebac-fitness-assets-np.s3.eu-central-1.amazonaws.com/rebac-fitness-frontend/assets',
  STAGE: 'np',
  HOST: 'manage.np.gym-deals.de',
};
